export default "__VITE_PUBLIC_ASSET__5ef6f985__"